function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 20.5l8.333 4.167 8.334-4.167M8 16.333l8.333 4.167 8.334-4.167M16.333 8L8 12.167l8.333 4.166 8.334-4.166L16.333 8z",
  stroke: "#5AC49D",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgIconAimatePro = function SvgIconAimatePro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMjAuNUwxNi4zMzMzIDI0LjY2NjdMMjQuNjY2NyAyMC41TTggMTYuMzMzM0wxNi4zMzMzIDIwLjVMMjQuNjY2NyAxNi4zMzMzTTE2LjMzMzMgOEw4IDEyLjE2NjdMMTYuMzMzMyAxNi4zMzMzTDI0LjY2NjcgMTIuMTY2N0wxNi4zMzMzIDhaIiBzdHJva2U9IiM1QUM0OUQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgIconAimatePro as ReactComponent };